import { useEffect, useState } from 'react';
import { GeoFeatureCollection } from '../geojsonUtils'
import geojson_ from "../somalia-districts.geojson";

interface UseDistrictGeoJsonResult {
  geojson: GeoFeatureCollection | null;
  loading: boolean;
  error: string | null;
}

/**
 * Fetches the district boundary GeoJSON on mount. This file is large
 * (~450KB) and doesn't change often, so it's fetched as a static asset
 * rather than routed through the Django API â€” place it in your app's
 * public/geo/ directory. Swap the URL below if you'd rather serve it from
 * the backend instead.
 */
export function useDistrictGeoJson(
  url = geojson_,
): UseDistrictGeoJsonResult {
  const [geojson, setGeojson] = useState<GeoFeatureCollection | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchGeojson = async () => {
      try {
        setLoading(true);
        setError(null);

        const res = await fetch(url);
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }

        const data = await res.json();
        setGeojson(data);
      } catch (err) {
        console.error(err);
        setError(err instanceof Error ? err.message : 'Failed to load map data');
      } finally {
        setLoading(false);
      }
    };

    fetchGeojson();
  }, [url]);

  return { geojson, loading, error };
}